import styles from "../../styles/results.module.css";

const Field = ({ text }: { text: string }) => {
  return <span className={styles.typography_primary}>{text}</span>;
};

export default Field;
